import { Checkbox } from '../Checkbox';

export const Caller = ({ callerName, checked, onChange }) => {
  return (
    <label className="flex items-center justify-between py-1 pl-[38px] cursor-pointer rounded-lg hover:bg-brand-300/[0.08]">
      <div className="flex items-center gap-2 truncate">
        <Checkbox checked={checked} onChange={onChange} />
        <span className="text-[16px]/[24px] text-base-1000 truncate">
          {callerName}
        </span>
      </div>
    </label>
  );
};
